module.exports = "<div class=\"gh-bar-inner\"></div><div class=\"gh-bar-inner\"></div><div class=\"gh-bar-inner\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/LoadingBar/LoadingBar.pug
// module id = 38
// module chunks = 0 1